import { $qs, $qsa } from '@js/utils/querySelector';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Controller } from 'swiper/modules';

function slider(block) {
    const contentSlider = $qs('[data-target="quotes-content-slider"]', block);
    const imageSlider = $qs('[data-target="quotes-image-slider"]', block);

    const contentSwiper = new Swiper(contentSlider, {
        modules: [Navigation, EffectFade, Pagination, Controller],
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
    });

    if (imageSlider) {
        const imageSwiper = new Swiper(imageSlider, {
            modules: [Navigation, EffectFade, Controller],
            slidesPerView: 1,
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
        });

        contentSwiper.controller.control = imageSwiper;
        imageSwiper.controller.control = contentSwiper;
    }
}

function quotes() {
    const blocks = $qsa('[data-block="quotes"]');

    if (!blocks) return;
    
    blocks.forEach(block => {
        slider(block);
    });
}

export default quotes;